import React from "react";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const ParksHeader = () => {
  return (
    <>
      <WelcomeText>{Text.landingWelcomeText} </WelcomeText>
      <WelcomeText2>{Text.landingWelcomeText2}</WelcomeText2>
      <InfoText>{Text.landingInfoText}</InfoText>
    </>
  );
};

const WelcomeText = styled.span`
  color: ${Colors.veryDarkBlue};
  text-align: center;
  font-family: Poppins;
  font-size: 2rem;
  font-style: normal;
  font-weight: 400;
  padding: 0 1rem;
  @media (max-width: 700px) {
    font-size: 1.1rem;
  }
`;

const WelcomeText2 = styled(WelcomeText)`
  // margin-top: 0rem;
  font-weight: 600;
`;

const InfoText = styled.span`
  color: ${Colors.grey40};
  text-align: center;
  align-self: center;
  font-family: Poppins;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  margin-top: 1.5rem;
  padding: 0 1.5rem;
  @media (max-width: 700px) {
    font-size: 1rem;
  }
`;

export default ParksHeader;
